import { atom } from "recoil";

export const formsSidebarActiveAtom = atom<boolean>({
	key: "formsSidebarActive",
	default: false,
});

// Atom to share the portal target element from AppSwitcher to FormDetail
export const formsSidebarPortalTargetAtom = atom<HTMLElement | null>({
	key: "formsSidebarPortalTarget",
	default: null,
	// Mark as dangerouslyAllowMutability since HTMLElement is mutable
	dangerouslyAllowMutability: true,
});
